import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Flight } from '@app/booking/booking.types';

@Component({
  selector: 'flight-detail',
  templateUrl: './flight-detail.component.html',
  styleUrls: ['./flight-detail.component.scss'],
  standalone: false,
})
export class FlightDetailComponent {
  @Input() flight: Flight;

  dir: string;

  constructor(private translateService: TranslateService) {
    this.dir = this.translateService.currentLang === 'ar' ? 'rtl' : 'ltr';
  }
}
